import {translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useMemo} from "react";

export type PasswordRule = {
	type: string;
	text: string;
	error: string;
	test: (password: string) => boolean;
}

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 30;

export default function usePasswordRules(): PasswordRule[] {
	return useMemo<PasswordRule[]>(() => [
		{
			type: "password-01-requirement",
			text: translation(PermitTranslations.validation__password_rules__01_text),
			error: translation(PermitTranslations.validation__password_rules__01_requirement, {value: PASSWORD_MIN_LENGTH}),
			test: (password: string) => password.length >= PASSWORD_MIN_LENGTH
		},
		{
			type: "password-05-requirement",
			text: translation(PermitTranslations.validation__password_rules__05_text),
			error: translation(PermitTranslations.validation__password_rules__05_requirement, {value: PASSWORD_MAX_LENGTH}),
			test: (password: string) => password.length <= PASSWORD_MAX_LENGTH
		},
		{
			type: "password-02-requirement",
			text: translation(PermitTranslations.validation__password_rules__02_text),
			error: translation(PermitTranslations.validation__password_rules__02_requirement),
			test: (password: string) => /[a-z]/.test(password) && /[A-Z]/.test(password)
		},
		{
			type: "password-03-requirement",
			text: translation(PermitTranslations.validation__password_rules__03_text),
			error: translation(PermitTranslations.validation__password_rules__03_requirement),
			test: (password: string) => /[a-zA-Z]/.test(password) && /\d/.test(password)
		},
		{
			type: "password-04-requirement",
			text: translation(PermitTranslations.validation__password_rules__04_text),
			error: translation(PermitTranslations.validation__password_rules__04_requirement),
			test: (password: string) => /[!@#$%^&*()_+{}|:"<>.?]/.test(password)
		}
	], []);
}
